import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarDateFormatter, CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppCalendarComponent } from './calendar.component';
import { CalendarService } from './services/calendar.service';
import { CustomDateFormatter } from './providers/custom-date-formatter.provider';
import { MaterialModule } from '@shared/material.module';

@NgModule({
  declarations: [
    AppCalendarComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    MaterialModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [
    CalendarService,
    { provide: CalendarDateFormatter, useClass: CustomDateFormatter },
  ],
  exports: [
    AppCalendarComponent,
  ]
})
export class CalendarAppModule { }
